module.exports = __webpack_public_path__ + "static/media/icon-completed.3fbce9fd.svg";